import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { SupplierQuote } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const useSupplierQuotes = (processId?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetSupplierQuotes
    )
    const [quotes, setQuotes] = useState<SupplierQuote[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const load = useCallback(async () => {
        if (!processId) return
        setLoading(true)
        try {
            const result = await useCase.execute(processId)
            setQuotes(result ?? [])
        } catch (e) {
            console.error(e)
            setQuotes([])
        }
        setLoading(false)
    }, [useCase, processId])

    useEffect(() => {
        load()
    }, [load])

    return { quotes, loading, reload: load }
}
